import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { ButtonsContainer, CancelButton, ConfirmButton } from './styled-components'

const ModalButtons = ({ onCancel, onConfirm, disabled, hidden }) => {
  const { t } = useTranslation()
  if (hidden) {
    return null
  }
  return (
    <ButtonsContainer>
      <CancelButton onClick={onCancel}>{t('subscriptionForm:contract_modal.cancel_button')}</CancelButton>
      <ConfirmButton disabled={disabled} onClick={onConfirm}>
        {t('subscriptionForm:contract_modal.confirm_button')}
      </ConfirmButton>
    </ButtonsContainer>
  )
}

ModalButtons.propTypes = {
  hidden: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
}

export default ModalButtons
